export default __webpack_public_path__ + "static/media/da043825-5894-4097-87f5-8b978b79d1d9.30e9e3a5.jpg";